<template>
  <div class="item-detail" v-if="item">
    <van-panel :title="item.name" :desc="item.labName" :status="price"/>
    <van-cell use-slot title="编号:" size="mini" :value="item.code" />
    <van-cell use-slot title="样本要求:" size="mini" :value="item.sampleRequire" />
    <van-cell use-slot title="保存条件:" size="mini" :value="item.storageCondition" />
    <van-cell use-slot title="报告时间:" size="mini" :value="item.reportTime" />
    <van-cell use-slot title="检验方法:" size="mini" :value="item.inspectionMethod" />
    <van-cell use-slot title="材料:" size="mini" :value="tubeNames" />
    <van-cell center title="临床应用:" :label="item.clinicalApply" />
    <van-cell center title="详情介绍" :label="item.summary" />
  </div>
</template>
<script>
import {getItem} from "@/api";
import Vue from "vue";
import {mapState} from "vuex";
import store from "@/store";

export default {
  name: "orderDetail",
  components: {},
  data() {
    return {
      id: null,
      item: undefined
    }
  },
  computed: {
    ...mapState({
      tokenInfo: "tokenInfo",
    }),
    price() {
      if (this.item) {
        return '￥' + (this.item.price / 100).toFixed(2)
      }
      return '￥0.00'
    },
    tubeNames() {
      if (this.item) {
        return this.item.tubes.map(t => t.name).join(',')
      }
      return '-'
    }
  },
  watch: {},
  created() {

  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      getItem(this.id).then(res => {
        this.item = res
        console.log(this.item)
      })
    } else {
      this.$toast("数据加载错误，请稍后重试");
    }
  },
  destroy() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.item-detail {
  position: relative;
  .item-summary {
    padding: 0.625rem 1rem;
    color: #323233;
    font-size: 0.875rem;
    line-height: 1.5rem;
    background-color: #fff;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: border-box;
    width: 100%;
  }
}
</style>
